import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../state/auth/AuthContext.jsx";
import { getStoredToken } from "@/utils/authStorage.js";

export default function PrivateRoute() {
  const { isAuth, token } = useAuth();
  const location = useLocation();

  const hasToken = token || getStoredToken();

  if (!isAuth && !hasToken) {
    console.log('Acceso denegado - Redirigiendo a login desde:', location.pathname);
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
